const inquiryForms = () => {
    $('#events_inquiry_form').on('submit', function(e) {
        e.preventDefault();

		const form = $(this);

        $('#events_inquiry_form #edit-actions-submit').val('Submitting');
		form.addClass('submitting');

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: main__js_vars.ajaxurl,
			data: form.serialize() + '&action=ajax_submit_events_inquiry',
			success: function (data) {	
				window.location.href = form.data('redirect');
			},
			error : function (jqXHR, textStatus, errorThrown) {
				$(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
				console.log(jqXHR);
			},
		});        
    });

	$('#general_inquiry_form').on('submit', function(e) {
        e.preventDefault();

		const form = $(this);

        $('#general_inquiry_form #edit-actions-submit').val('Submitting');
		form.addClass('submitting');

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: main__js_vars.ajaxurl,
			data: form.serialize() + '&action=ajax_submit_general_inquiry',
			success: function (data) {	
				window.location.href = form.data('redirect');
			},
			error : function (jqXHR, textStatus, errorThrown) {
				$(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
				console.log(jqXHR);
			},
		});        
    });
};